import type { StaticProvider } from '@angular/core';
import { setAppConfig } from '@onviobr/app-info';
import { environment } from './environments/environment';
import { initializeDatadogStaffApp } from './staff-datadog';
import './micro-front-end-modules';

window['onvio_namespace'] = {};

Object.defineProperty(window, 'wijmo', {
	set(value) {
		window['onvio_namespace']['wijmo'] = {
			...window['onvio_namespace']['wijmo'],
			...value
		};
	},
	get(): any {
		return window['onvio_namespace']['wijmo'];
	}
});

setAppConfig({
	verticalName: environment.verticalName,
	version: environment.version
});

initializeDatadogStaffApp();

async function bootstrapAngular(extra: StaticProvider[]): Promise<any> {
	const { enableProdMode } = await import('@angular/core');
	const { platformBrowserDynamic } = await import('@angular/platform-browser-dynamic');
	const { ngAddGlobalExtras } = await import('@onviobr/mfe-loader');
	enableProdMode();
	const { AppModule } = await import('./app/app.module');

	const ngPlatform = platformBrowserDynamic(extra);

	ngAddGlobalExtras({ ngPlatform });

	return ngPlatform
		.bootstrapModule(AppModule)
		.catch(err => console.log(err));
}

async function bootstrapAngularJS() {
	const { onLanguageChange, getCurrentLanguage } = await import('@onviobr/services/i18n');
	const { loadWijmoLocale } = await import('./wijmo/wijmo-initializer');

	onLanguageChange(() => {
		const lang = getCurrentLanguage();
		loadWijmoLocale(lang);
	});

	const { getDowngradedComponents } = await import('./downgraded-components');

	const downgraded = getDowngradedComponents(bootstrapAngular);

	// This will run the function to re-add angularJS wijmo constructors that we use
	window['angular'].bootstrap(document.documentElement, ['core', downgraded.name], { strictDi: true });
}

import('./wijmo/wijmo-initializer')
	.then(({ initializeGlobals }) => initializeGlobals())
	.then(() => import('./legacy-dependency-share'))
	.then(() => System.import('legacy-code'))
	.then(bootstrapAngularJS)
	.catch(console.error);
